import i18n from "@common/src/i18n/i18n";
import { safeGetStorage } from "@common/src/utils/common";
import { isNil } from "lodash-es";

const storageKeyArr = {
  technicianTipsAutoShow: "se_technician_tips_auto_show",
  taxPayableDuringSettlement: "se_tax_pay_able_during_settlement"
};

const store = {
  namespaced: true,
  state: {
    currentTabType: "all",
    technicianTipsAutoShow: safeGetStorage(storageKeyArr["technicianTipsAutoShow"], true),
    taxPayableDuringSettlement: safeGetStorage(storageKeyArr["taxPayableDuringSettlement"], true),
    retailTypeOption: [
      {
        label: i18n.t("v210831.retail"),
        value: "1"
      },
      {
        label: i18n.t("speedbiz-v217_0.wholesale"),
        value: "2"
      }
    ]
  },
  getters: {},
  mutations: {
    setCurrentTabType(state, data) {
      state.currentTabType = data;
    },
    setTechnicianTipsAutoShow(state, data) {
      localStorage.setItem(storageKeyArr["technicianTipsAutoShow"], JSON.stringify(data));
      state.technicianTipsAutoShow = data;
    },
    setTaxPayableDuringSettlement(state, data) {
      if (!isNil(data)) {
        localStorage.setItem(storageKeyArr["taxPayableDuringSettlement"], JSON.stringify(data));
        state.taxPayableDuringSettlement = data;
      }
    }
  },
  actions: {
    async getUri({ rootState }, params = {}) {
      const data = await rootState.http("/order/my/invoicing/getUri", params);
      return data;
    },
    async email({ rootState }, params = {}) {
      const data = await rootState.http("/order/my/invoicing/email", params);
      return data;
    },
    async sms({ rootState }, params = {}) {
      const data = await rootState.http("/order/my/invoicing/sms", params);
      return data;
    },
    async getPrintStoreLogo({ rootState }, params = {}) {
      const data = await rootState.http("/printTemplate/getPrintStoreLogo", params);
      return data;
    },
    async queryAllChannel({ rootState }, params = {}) {
      const data = await rootState.http("/store/queryAllChannel", params);
      return data;
    },
    async queryExpress({ rootState }, params = {}) {
      const data = await rootState.http("/order/queryExpress", params);
      return data;
    },
    async receive({ rootState }, params = {}) {
      const data = await rootState.http("/order/receive", params);
      return data;
    },
    async getCarSettlementList({ rootState }, params = {}) {
      const data = await rootState.http("/order/getCarSettlementList", params);
      return data;
    },
    async filterCustomerCoupons({ rootState }, params = {}) {
      const data = await rootState.http("/promotion/coupon/store/filterCustomerCoupons", params);
      return data;
    },
    async onAccount({ rootState }, params = {}) {
      const data = await rootState.http("/order/onAccount", params);
      return data;
    },
    async createMaintenanceOrder({ rootState }, params = {}) {
      const data = await rootState.http("/order/createOrder/maintenance", params);
      return data;
    },
    async updateOrder({ rootState }, params = {}) {
      const data = await rootState.http("/order/updateOrderInfo", params);
      return data;
    },
    async createWashOrder({ rootState }, params = {}) {
      const data = await rootState.http("/order/createOrder/carWash", params);
      return data;
    },
    async createRetailOrder({ rootState }, params = {}) {
      const data = await rootState.http("/order/createOrder/retail", params);
      return data;
    },
    async getOrderList({ rootState }, params = {}) {
      const data = await rootState.http("/order/queryOrderList", Object.assign(params, { clientType: "10" }));
      return data;
    },
    async getOrderDetail({ rootState }, params = {}) {
      const data = await rootState.http("/order/getOrderDetail", Object.assign(params, { clientType: "10" }));
      return data;
    },
    async settlementOrder({ rootState }, params = {}) {
      const data = await rootState.http("/receipt/createOrderReceipt", params);
      return data;
    },
    async cancleOrder({ rootState }, params = {}) {
      const data = await rootState.http("/order/cancelOrder", params);
      return data;
    },
    async completeOrder({ rootState }, params = {}) {
      const data = await rootState.http("/order/completed", params, {
        errorMessage: false
      });
      return data;
    },
    async setAppointmentDate({ rootState }, params = {}) {
      const data = await rootState.http("/external/order/appointment", params);
      return data;
    },
    async setSupplementData({ rootState }, params = {}) {
      const data = await rootState.http("/external/order/supplement", params);
      return data;
    },
    async onlineVerificationCode({ rootState }, params = {}) {
      const data = await rootState.http("/external/order/verification", params);
      return data;
    },
    async createInvoice({ rootState }, params = {}) {
      const data = await rootState.http("/invoice/createInvoice", params);
      return data;
    },
    async getInvoiceInfo({ rootState }, params = {}) {
      const data = await rootState.http("/order/getInvoicedInfo", params);
      return data;
    },
    async orderArrival({ rootState }, params = {}) {
      const data = await rootState.http("/external/order/arrival", params);
      return data;
    },
    async getAppointmentCalender({ rootState }, params = {}) {
      const data = await rootState.http("/order/queryReservations", params);
      return data;
    },
    async getInvoiceTitleList({ rootState }, params = {}) {
      const data = await rootState.http("/invoice/queryInvoiceTitleList", params);
      return data;
    },
    async returnOrder({ rootState }, params = {}) {
      const data = await rootState.http("/order/trade/returnOrder", params);
      return data;
    },
    async queryReturnOrderParts({ rootState }, params = {}) {
      const data = await rootState.http("/order/trade/queryReturnOrderParts", params);
      return data;
    },
    async queryReturnOrderStaffCommission({ rootState }, params = {}) {
      const data = await rootState.http("/order/trade/queryReturnOrderStaffCommission", params);
      return data;
    },
    async queryStationList({ rootState }, params = {}) {
      const data = await rootState.http("/station/query", params);
      return data;
    },
    async insertStation({ rootState }, params = {}) {
      const data = await rootState.http("/station/save", params);
      return data;
    },
    async updateStationBySort({ rootState }, params = {}) {
      const data = await rootState.http("/station/sort", params);
      return data;
    },
    async deleteStation({ rootState }, params = {}) {
      const data = await rootState.http("/station/remove", params);
      return data;
    },
    async updateStationByStatus({ rootState }, params = {}) {
      const data = await rootState.http("/station/modifyEnableStatus", params);
      return data;
    },
    async queryDispatchStationList({ rootState }, params = {}) {
      const data = await rootState.http("/order/assignTask/queryStationArray", params);
      return data;
    },
    async queryDispatchOrderList({ rootState }, params = {}) {
      const data = await rootState.http("/order/assignTask/queryAssignTaskQueue", params);
      return data;
    },
    async queryDispatchStaffList({ rootState }, params = {}) {
      const data = await rootState.http("/order/assignTask/queryTechnicianArray", params);
      return data;
    },
    // 车间看板
    // 获取订单列表施工超时时间*
    async getOrderTimeoutDashboard({ rootState }, params = {}) {
      const data = await rootState.http("/order/dashboard/getOrderTimeout", params);
      return data;
    },
    // 查询今日订单概况
    async queryTodayOrderDashboard({ rootState }, params = {}) {
      const data = await rootState.http("/order/dashboard/queryTodayOrder", params);
      return data;
    },
    // 设置订单列表施工超时时间*
    async settingOrderTimeoutDashboard({ rootState }, params = {}) {
      const data = await rootState.http("/order/dashboard/settingOrderTimeout", params);
      return data;
    },
    // 统计技师订单工时 柱状图
    async statisticTechnicianWorkingHoursDashboard({ rootState }, params = {}) {
      const data = await rootState.http("/order/dashboard/statisticTechnicianWorkingHours", params);
      return data;
    },
    // 统计技师订单工时 饼图
    async statisticalTodayOrderDashboard({ rootState }, params = {}) {
      const data = await rootState.http("/order/dashboard/statisticalTodayOrder", params);
      return data;
    },
    // 派工
    async updateOrderByDispatch({ rootState }, params = {}) {
      const data = await rootState.http("/order/assignTask/assign", params);
      return data;
    },
    // 取消派工
    async updateDispatchByCancel({ rootState }, params = {}) {
      const data = await rootState.http("/order/assignTask/cancelAssign", params);
      return data;
    },
    // 确认订单
    async orderConfirm({ rootState }, params = {}) {
      const data = await rootState.http("/order/confirm", params);
      return data;
    },
    async requestShipment({ rootState }, params = {}) {
      const data = await rootState.http("/external/order/request-shipment", params);
      return data;
    },
    async rejection({ rootState }, params = {}) {
      const data = await rootState.http("/order/rejection", params);
      return data;
    },
    // 修改保养信息 保养时间，当前里程 等
    async modifyCustomerMaintenanceInfo({ rootState }, params = {}) {
      const data = await rootState.http("/order/modifyCustomerMaintenanceInfo", params);
      return data;
    },
    async checkRepeatCreateOrder({ rootState }, params = {}) {
      const data = await rootState.http("/order/findTodayLastOrder", params);
      return data;
    },
    async orderPayment({ rootState }, params = {}) {
      const data = await rootState.http("/store/order/orderPayment", params);
      return data;
    },
    async calculateTax({ rootState }, params = {}) {
      const data = await rootState.http("/store/order/orderPayment/calculateTax", params);
      return data;
    },
    async getOptionDetail({ rootState }, params = {}) {
      const data = await rootState.http("/order/invoice/getOptionDetail", params);
      return data;
    },
    async selectInvoiceDetail({ rootState }, params = {}) {
      const data = await rootState.http("/order/invoice/selectInvoiceDetail", params);
      return data;
    }
  }
};

export default store;
